// HTMLの生成はRails側で行うため、全体はComponentを作らない
import {
  onMounted,
  ref
} from 'vue'

import { useAjax } from '@composables/useAjax.js'
import { useIntlTel } from '@composables/useIntlTel.js'
import { preventEnterSubmit } from '@shared/util.js'

export default {
  setup() {
    const {
      intlCountry,
      intlNumber,
      initializeIntlTel
    } = useIntlTel("#intl_phone")

    const { country, phone } = window.app.page

    const refEmail = ref(null)
    const sentVerificationCode = ref(false)
    const submitting = ref(false)

    onMounted(() => {
      moveErrorText()
      initializeIntlTel({ country, phone })
      $(".search-property-type-detail option:first").prop('disabled', true);
      $(".search-property-type-detail").SumoSelect();
      $(".select-property-type option:first").prop('disabled', true);
      $(".search-price-to option:first").prop('disabled', true);
      $(".search-price-to").SumoSelect();
      preventEnterSubmit()
    })

    const handleClickGetCode = async () => {
      const { callPost } = useAjax()

      submitting.value = true
      const url = new URL(location.href)
      url.pathname = `${url.pathname}/send_verification_code.json`
      const response = await callPost(url.toString(), { email: refEmail.value.value })
      if (response.code == 'success') {
        sentVerificationCode.value = true
      }

      submitting.value = false
    }

    const handleCloseSentVerificationCode = () => sentVerificationCode.value = false

    const handleSubmit = () => submitting.value = true

    const moveErrorText = () => {
      // 強引だけど、位置を調整する
      const element = document.querySelector('.group.code')
      const error = element.querySelector('.error_txt')
      if (error) {
        element.appendChild(error)
      }
    }

    return {
      // variables
      intlCountry,
      intlNumber,
      refEmail,
      sentVerificationCode,
      submitting,
      // methods
      handleClickGetCode,
      handleCloseSentVerificationCode,
      handleSubmit,
    }
  },
}
